// /settings/letter-templates — список писем каталога по группам и общие фразы (042: T021).
// Право проверяет общий маршрут раздела (settings.letter-templates.tsx).
import { createFileRoute } from '@tanstack/react-router';
import { LetterTemplatesPage } from '../../../features/letter-templates/list/LetterTemplatesPage.tsx';

export const Route = createFileRoute('/_app/_settings/settings/letter-templates/')({
  component: LetterTemplatesPage,
});
